import script from "./HrBrandedFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HrBrandedFormPage.vue?vue&type=script&setup=true&lang=js"

import "./HrBrandedFormPage.vue?vue&type=style&index=0&id=06f20489&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f20489"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
